import { useForkRef } from "@mui/material/utils";

import { useActionsMenuClose } from "ui/actions-menu/actions-menu-context";

import { type MenuItemProps } from "ui/actions-menu/menu-item/menu-item.types";

type UseMenuItemProps = Pick<MenuItemProps, "onClick" | "color" | "tooltip" | "ref">;

/**
 * Splits `tooltip` into its two forms — a message for the whole row, or a trailing icon with a message
 * of its own — and closes the enclosing `ActionsMenu` after the item's own `onClick`.
 */
export const useMenuItem = ({ onClick, color, tooltip, ref }: UseMenuItemProps) => {
  const closeMenu = useActionsMenuClose();

  /**
   * A callback ref, because each `component` the item renders as narrows MUI's ref to its own element
   * type; a `Ref<HTMLElement>` object would not be assignable to any of them.
   */
  const itemRef = useForkRef(ref);

  const handleClick = () => {
    onClick();
    closeMenu?.();
  };

  return {
    isCritical: color === "error",
    rowTooltip: typeof tooltip === "string" && tooltip ? tooltip : null,
    trailingTooltip: typeof tooltip === "object" ? tooltip : null,
    itemRef,
    handleClick,
  };
};
